import React, {useEffect, useContext} from "react";
import Verify from "../views/verify/Verify";
import Footer from "./footer/Footer";
import {Main} from "../styles/GlobalStyles";
import Header from "./header/Header";
import {useLocation, useHistory} from "react-router-dom";
import {GlobalContext} from "../context/GlobalContext";
import useQuery from "../hooks/useQuery";
import usePrevious from "../hooks/usePrevious";

function Container({children}) {
   const {setMenu, isAdult, setIsAdult} = useContext(GlobalContext);
   let location = useLocation();
   let history = useHistory();
   let query = useQuery();
   /*   let {length} = history;
   const prevLength = usePrevious(length); */

   useEffect(() => {
      //  al cambiar la ruta hacer scroll al inicio de la pantalla
      if (history.action === "PUSH") {
         setTimeout(() => {
            window.scrollTo({top: 0, behavior: "smooth"});
         }, 100);
      }
   }, [history]);
   
   useEffect(() => {
      //  al cambiar la ruta cerramos el menú
      setMenu(false);
   }, [location]);

   // si es adulto devuelve el contenido general
   if (isAdult)
      return (
         <>
            <Header />
            <Main>{children}</Main>
            <Footer />
         </>
      );
   // si no es adulto, pide que ingrese su edad
   return <Verify updateStatus={setIsAdult} />;
}

export default Container;
